// extracted by mini-css-extract-plugin
export var closeButton = "_i4-2";
export var closeButtonIcon = "_i4-3";
export var lightboxContent = "_i4-1";
export var lightboxOverlay = "_i4-0";